/* TRE Motion - scroll reveals with stagger. Skips reduced-motion, Shopify design mode, and anything already in the viewport (no flicker). */
(function(){
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(window.Shopify&&Shopify.designMode)return;
  if(!('IntersectionObserver' in window))return;
  var sels=['.tre-trust__item','.tre-cards .tre-card','.tre-recs .tre-rec','.tre-desk','.tre-sec__h','.blog-articles .article-card-wrapper','.tre-bhub__chips','.multicolumn-list__item'];
  var els=document.querySelectorAll(sels.join(','));
  if(!els.length)return;
  var vh=window.innerHeight;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('tre-in');io.unobserve(e.target);}
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.12});
  els.forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.top<vh*0.85)return; /* above the fold: never hide what is already visible */
    var idx=el.parentElement?Array.prototype.indexOf.call(el.parentElement.children,el):0;
    el.style.setProperty('--tre-d',(Math.min(idx,5)*80)+'ms');
    el.classList.add('tre-reveal');
    io.observe(el);
  });
})();
